import { render, staticRenderFns } from "./BaseSheet.vue?vue&type=template&id=6c634744&"
import script from "./BaseSheet.vue?vue&type=script&lang=js&"
export * from "./BaseSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports